export const supportedTimezones: Array<{ key: string; label: string }> = [
    { key: 'America/New_York', label: '[-05] America/New_York (Eastern)' },
    { key: 'America/Chicago', label: '[-06] America/Chicago (Central)' },
    { key: 'America/Boise', label: '[-07] America/Boise (Mountain)' },
    { key: 'America/Los_Angeles', label: '[-08] America/Los_Angeles (Pacific)' },
    { key: 'America/Anchorage', label: '[-09] America/Anchorage' },
    { key: 'Pacific/Honolulu', label: '[-10] Pacific/Honolulu' },
    { key: 'UTC', label: '[+00] UTC' }
];
